module.exports = __webpack_public_path__ + "media/images/weather/cloudy-077475327a7e63f3624fe3ab33d54787.jpg";